// extracted by mini-css-extract-plugin
export default {"no-content":"FailedRecommendation_no-content__XVV36"};